import { getAppPageConfig } from 'hb-react/frontoffice/utils/page';

const getTopicsMenuName = (currentNetwork) =>
  getAppPageConfig('topics', currentNetwork)?.menu_name;

export default getTopicsMenuName;
